// @ts-nocheck: converted from JS

import Animals from '@/components/Animals';

export default Animals;
